module.exports = __webpack_public_path__ + "static/media/delete_dark.2f1bda70.svg";